import { render, staticRenderFns } from "./qrcode_for_wiki.vue?vue&type=template&id=34d7138a&scoped=true&"
import script from "./qrcode_for_wiki.vue?vue&type=script&lang=js&"
export * from "./qrcode_for_wiki.vue?vue&type=script&lang=js&"
import style0 from "./qrcode_for_wiki.vue?vue&type=style&index=0&id=34d7138a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34d7138a",
  null
  
)

export default component.exports